export const statusStyleMap = {
  OPEN: {
    bg: 'var(--sys-color-tertiary)',
    text: 'var(--ref-color-blackwhite-white)',
    icon: 'var(--ref-color-blackwhite-white)',
  },
  CLOSED: {
    bg: 'var(--ref-color-gray-20)',
    text: 'var(--ref-color-gray-80)',
    icon: 'var(--ref-color-gray-80)',
  },
  AWAITING_RESPONSE: {
    bg: 'var(--sys-color-primary)',
    text: 'var(--ref-color-blackwhite-black)',
    icon: 'var(--ref-color-blackwhite-black)',
  },
} as const;

export type StatusType = keyof typeof statusStyleMap;
